/**
 * Groupes internes TriggerFlow et Thaïs : des hôtels y sont rattachés EN PLUS de leur
 * vrai groupe. Ni classement, ni accueil de groupe pour eux. Miroir de
 * `FacilityGroupConnections::INTERNAL_GROUP_IDS` (backend).
 */
export const INTERNAL_GROUP_IDS: readonly number[] = [8, 87];

export function isInternalGroup(facilityId?: number | null): boolean {
    return facilityId != null && INTERNAL_GROUP_IDS.includes(facilityId);
}
